<template>
	<div>
		<div class="section-gap primary pb-5">
			<v-container grid-list-xl py-0>
				<v-layout row wrap align-center justify-center>
					<v-flex xs12 sm12 md6 lg6 xl6>
						<div class="subscribe-content">
							<h1 class="translate-right white--text">
								¡Tenemos el plan que necesitas!
							</h1>
							<p class="body-1 translate-left white--text">
								Todos nuestros planes incluyen soporte y certificado digital.
							</p>
						</div>
					</v-flex>
					<v-flex xs12 sm12 md6 lg6 xl6>
						<div class="subscribe-content">
							<div class="emb-aside-banner-v1 text-right">
								<img
									class="emb-card"
									alt="aside-banner"
									src="/static/images/functionalities.jpg"
									width="547"
									height="315"
								/>
							</div>
						</div>
					</v-flex>
				</v-layout>
			</v-container>
		</div>
		<v-container grid-list-xl>
			<v-row dense>
				<v-col cols="12" xl="6" offset-xl="5">
					<v-radio-group v-model="type" row>
						<v-radio label="Mensual" :value="true"></v-radio>
						<v-radio label="Anual" :value="false"></v-radio>
					</v-radio-group>
				</v-col>
			</v-row>
			<v-layout row wrap text-center>
				<v-flex xs12 sm12 md12 lg4 xl4>
					<v-card class="mx-auto" hover>
						<v-img
							class="white--text align-center"
							gradient="to bottom, rgba(0,0,0,.9), rgba(0,0,0,.9)"
							height="200px"
							src="/static/images/house.jpg"
						>
							<h5 class="white--text">BÁSICO</h5>
							<h3 class="white--text">S/ {{ !type ? '600.00' : '55.00' }}</h3>
							<h6 class="white--text">{{ !type ? 'Anual' : 'Mensual' }}</h6>
						</v-img>

						<v-card-text class="text--primary">
							<div class="my-2 font-weight-medium">300 Comprobantes por mes</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">1 Punto de venta</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">1 Almacén</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">
								1 Usuario y Productos ilimitados
							</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Panel de reportes en línea</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Ventas al crédito</div>
						</v-card-text>

						<v-card-actions>
							<v-btn color="accent" block rounded outlined>
								Comenzar
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-flex>
				<v-flex xs12 sm12 md12 lg4 xl4>
					<v-card class="mx-auto" hover>
						<v-img
							outlined
							class="align-center"
							gradient="to bottom, rgba(0,0,0,.9), rgba(0,0,0,.9)"
							height="200px"
							src="/static/images/house.jpg"
						>
							<h5 class="white--text">EMPRESARIAL</h5>
							<h3 class="white--text">S/ {{ !type ? '715.00' : '65.00' }}</h3>
							<h6 class="white--text">{{ !type ? 'Anual' : 'Mensual' }}</h6>
						</v-img>

						<v-card-text class="text--primary">
							<div class="my-2 font-weight-medium">Hasta 500 Comprobantes por mes</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">2 Puntos de venta</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">2 Almacenes</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">
								2 Usuarios y Productos limitados
							</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Compras al crédito</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Ventas al crédito</div>
						</v-card-text>

						<v-card-actions>
							<v-btn color="accent" block rounded outlined>
								Comenzar
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-flex>
				<v-flex xs12 sm12 md12 lg4 xl4>
					<v-card class="mx-auto" hover>
						<v-img
							class="align-center"
							gradient="to bottom, rgba(0,0,0,.9), rgba(0,0,0,.9)"
							height="200px"
							src="/static/images/house.jpg"
						>
							<h5 class="white--text">PREMIUM</h5>
							<h3 class="white--text">S/ {{ !type ? '847.00' : '77.00' }}</h3>
							<h6 class="white--text">{{ !type ? 'Anual' : 'Mensual' }}</h6>
						</v-img>

						<v-card-text class="text--primary">
							<div class="my-2 font-weight-medium">Comprobantes ilimitados</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Puntos de venta ilimitados</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Almacenes ilimitados</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Reportes y gráficos estadísticos</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">
								Usuarios y productos limitados
							</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Todos los módulos</div>
						</v-card-text>

						<v-card-actions>
							<v-btn color="accent" block rounded outlined>
								Comenzar
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-flex>
			</v-layout>
			<v-layout row wrap text-center>
				<v-flex xs12 sm12 md12 lg12 x12>
					<h2 class="mt-4">PREMIUM restaurantes</h2>
				</v-flex>
			</v-layout>
			<v-row>
				<v-col cols="12" xl="4" offset-xl="4">
					<v-card class="mx-auto text-center" hover>
						<v-img
							class="align-center"
							gradient="to bottom, rgba(0,0,0,.9), rgba(0,0,0,.9)"
							height="200px"
							src="/static/images/house.jpg"
						>
							<h5 class="white--text">PREMIUM</h5>
							<h3 class="white--text">S/ {{ !type ? '2,079.00' : '189.00' }}</h3>
							<h6 class="white--text">{{ !type ? 'Anual' : 'Mensual' }}</h6>
						</v-img>

						<v-card-text class="text--primary">
							<div class="my-2 font-weight-medium">Comprobantes ilimitados</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Puntos de venta ilimitados</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Almacenes ilimitados</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Promociones</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">
								Usuarios y Productos ilimitados
							</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Reservas</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Delivery</div>
							<v-divider></v-divider>
							<div class="my-2 font-weight-medium">Carta QR</div>
						</v-card-text>

						<v-card-actions>
							<v-btn color="accent" block rounded outlined>
								Comenzar
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
export default {
	data() {
		return {
			type: true,
		};
	},
	beforeCreate() {
		document.title = 'Planes | Sislii';
	},
};
</script>
